import { OrderStatusKeyEnum } from "@core/enums/order-status-key.enum";

export const orderStatusColorsSet: Record<OrderStatusKeyEnum, string> = {
    [OrderStatusKeyEnum.REPORTED]: "grey",
    [OrderStatusKeyEnum.PLANNED]: "purple",
    [OrderStatusKeyEnum.IN_PROGRESS]: "blue",
    [OrderStatusKeyEnum.COMPLETED]: "green",
    [OrderStatusKeyEnum.INVOICED]: "black",
    [OrderStatusKeyEnum.CANCELED]: "red",
};